import React from 'react';
import { CORES_GRAFICO } from '../../utils/graficos';

/**
 * Gráfico donut em SVG puro — sem dependência externa.
 *
 * Props:
 *  - data: [{ label, value, color }]
 *  - size: diâmetro em px (padrão 180)
 *  - thickness: espessura do anel (padrão 32)
 *  - centro: texto central (opcional, ex: total formatado)
 *  - centroSub: subtexto abaixo do centro (opcional)
 */

export default function DonutChart({ data, size = 180, thickness = 32, centro, centroSub }) {
  if (!data || data.length === 0) return null;

  const total = data.reduce((s, d) => s + (d.value || 0), 0);
  if (total === 0) return null;

  const r = (size - thickness) / 2;
  const circ = 2 * Math.PI * r;
  const cx = size / 2;
  const cy = size / 2;

  let offset = 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: 'block' }}>
        {data.map((item, i) => {
          const pct = item.value / total;
          const dash = pct * circ;
          const gap = circ - dash;
          const cor = item.color || CORES_GRAFICO[i % CORES_GRAFICO.length];
          const segmento = (
            <circle
              key={i}
              cx={cx}
              cy={cy}
              r={r}
              fill="none"
              stroke={cor}
              strokeWidth={thickness}
              strokeDasharray={`${dash} ${gap}`}
              strokeDashoffset={-offset}
              strokeLinecap="butt"
              style={{ transition: 'stroke-dasharray 0.4s ease' }}
              transform={`rotate(-90 ${cx} ${cy})`}
            />
          );
          offset += dash;
          return segmento;
        })}
        {centro && (
          <>
            <text x={cx} y={centroSub ? cy - 4 : cy + 1} textAnchor="middle" dominantBaseline="middle"
              fontSize="15" fontWeight="700" fill="var(--text)">
              {centro}
            </text>
            {centroSub && (
              <text x={cx} y={cy + 14} textAnchor="middle" dominantBaseline="middle"
                fontSize="10" fill="var(--text-muted)">
                {centroSub}
              </text>
            )}
          </>
        )}
      </svg>

      {/* Legenda */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem 1rem', justifyContent: 'center', maxWidth: size + 80 }}>
        {data.map((item, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', fontSize: '0.75rem' }}>
            <div style={{ width: 10, height: 10, borderRadius: 2, background: item.color || CORES_GRAFICO[i % CORES_GRAFICO.length], flexShrink: 0 }} />
            <span style={{ color: 'var(--text-muted)' }}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
